import React from 'react'
import PropTypes from 'prop-types'
import {
    SimpleGrid,
    Stack,
    Grid,
    Box,
    Button,
    useDisclosure,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Region, regionPropType} from '@salesforce/commerce-sdk-react/components'

/**
 * This layout component displays its children in a 2 row x 1 column grid on mobile
 * and a 1 row x 2 column grid on desktop.
 *
 * @param {componentProps} props
 * @param {regionType []} props.regions - The page designer regions for this component.
 * @param {object} props.data - The data for the component.
 * @param {string} props.typeId - A mapping of typeId's to react components representing the type.
 * @returns {React.ReactElement} - Grid component.
 */
export const ShopTheLookLayout = ({regions}) => {
    const styles = useMultiStyleConfig('containerStyles')
    const {isOpen, onToggle} = useDisclosure()

    return (
        <Stack test-data-id="shop-the-look-layout" spacing={4} {...styles.containerStyles}>
            <Grid templateColumns={{base: '1fr', md: '2.1fr 1fr'}} gap={8} mb={4}>
                <Box>
                    <Region region={regions[0]} />
                </Box>
                <SimpleGrid columns={{base: 2, md: 1}} spacing={8}>
                    <Region region={regions[1]} />
                    <Region region={regions[2]} />
                </SimpleGrid>
            </Grid>
            {/* Show More button only on mobile */}
            <Box display={{base: isOpen ? 'none' : 'block', md: 'none'}} mb={4} textAlign="center">
                <Button size="sm" onClick={onToggle}>
                    Show More
                </Button>
            </Box>
            <Box display={{base: isOpen ? 'block' : 'none', md: 'block'}} mb={4}>
                <SimpleGrid columns={{base: 1, sm: 2, md: 3}} spacing={8}>
                    <Region region={regions[3]} />
                    <Region region={regions[4]} />
                    <Region region={regions[5]} />
                </SimpleGrid>
            </Box>
        </Stack>
    )
}

ShopTheLookLayout.displayName = 'ShopTheLookLayout'

ShopTheLookLayout.propTypes = {
    // Internally Provided
    regions: PropTypes.arrayOf(regionPropType).isRequired
}

export default ShopTheLookLayout
